/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import DeleteConfirmPopover from '../../../../../../../components/DeleteConfirmPopover';
import { EntityAddressContactType } from '../../../../../../../models/core/entities.type';
import theme from '../../../../../../../theme';

type DataViewActionProps = {
  item: EntityAddressContactType;
  confirmActionResult(item: EntityAddressContactType | null, action: string, confirmed: boolean): void;
  zIndex: number;
};

export default function AddressContactFormViewActions(props: DataViewActionProps) {
  return (
    <Group>
      <Tooltip
        withArrow
        transitionProps={{ transition: 'fade', duration: 200 }}
        label="Editar"
        zIndex={props.zIndex + 1}
      >
        <ActionIcon
          size="sm"
          color="primary"
          style={{ borderColor: theme?.colors?.accent?.[6] }}
          variant="outline"
          onClick={() => {
            props.confirmActionResult(props.item, 'editar', true);
          }}
        >
          <IconEdit size={15} color={theme?.colors?.accent?.[6]} />
        </ActionIcon>
      </Tooltip>
      <DeleteConfirmPopover
        label="Excluir"
        message="Esta ação removerá o contato."
        variant="outline"
        zIndex={props.zIndex + 1}
        onConfirm={() => {
          props.confirmActionResult(props.item, 'excluir', true);
        }}
        onCancel={() => {
          props.confirmActionResult(props.item, 'excluir', false);
        }}
      />
    </Group>
  );
}
